import React, { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Standards } from "@/components/site/Standards";
import { About } from "@/components/site/About";
import { CtaBand } from "@/components/site/CtaBand";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const [serviceInterest, setServiceInterest] = useState("");

  const handleInquire = (svc) => {
    setServiceInterest(svc.title);
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services onInquire={handleInquire} />
        <Standards />
        <About />
        <CtaBand />
        <Contact serviceInterest={serviceInterest} setServiceInterest={setServiceInterest} />
      </main>
      <Footer />
    </>
  );
}
